module.exports = __webpack_public_path__ + "img/vtv-sbt-2022.1548f202.png";